import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import html2canvas from 'html2canvas';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ScreenType } from 'src/app/enums/ScreenType';
import { UserRegDetails } from 'src/app/models/user';
import { endDateValidator } from 'src/app/utils/password-util';

@Component({
  selector: 'app-user-create-poll',
  templateUrl: './user-create-poll.component.html',
  styleUrls: ['./user-create-poll.component.scss'],
})
export class UserCreatePollComponent implements OnInit {
  @Output() onCreateUserPoll = new EventEmitter<any>();
  @Input() set userList(val: UserRegDetails[]) {
    this.setUserListdata(val);
  }
  @Input() set screen(val: ScreenType) {
    this.screenInfo = val;
  }
  screenInfo: ScreenType;
  users: UserRegDetails[];
  userControls: any;
  pollImage: string = '';
  selectedUsersControl = new FormControl();
  usersTemp: string[] = [];
  filteredHosts: UserRegDetails[] = [];
  minDate: Date;
  minTime: string;
  ngOnInit(): void {
    this.minDate = new Date();
    this.filteredHosts = this.users;

    // Subscribe to value changes in the filter input
    this.selectedUsersControl.valueChanges.subscribe((value) => {
      this.filteredHosts = this.filterHosts(value);
    });
    this.userControls = this.users.map(() => new FormControl(false));
    this.pollForm = this.formBuilder.group(
      {
        question: ['', Validators.required],
        options: this.formBuilder.array(['']),
        startDate: [null, Validators.required],
        completeStartDate: [null],
        completeEndDate: [null],
        startTime: [null, Validators.required],
        endDate: [null, Validators.required],
        endTime: [null, Validators.required],
        sendResultsTo: ['select', Validators.required],
        selected: this.formBuilder.array([], Validators.required),
        users: new FormArray(this.userControls),
        pollImage: [null],
      },
      {
        validator: endDateValidator(),
      }
    );
    this.pollForm.get('sendResultsTo').valueChanges.subscribe((value) => {
      if (value === 'select') {
        this.pollForm.get('selected').setValidators([Validators.required]);
      } else {
        this.pollForm.get('selected').clearValidators();
      }
      this.pollForm.get('selected').updateValueAndValidity();
    });
    this.pollForm
      .get('startDate')
      .valueChanges.subscribe((selectedDate: Date) => {
        this.updateMinTime(selectedDate);
      });
    this.pollForm.get('startTime').valueChanges.subscribe((time: any) => {});
  }
  pollForm: FormGroup;
  constructor(private formBuilder: FormBuilder) {}
  get options() {
    return this.pollForm.get('options') as FormArray;
  }

  get selected() {
    return this.pollForm.get('selected') as FormArray;
  }
  updateMinTime(selectedDate: Date): void {
    const today = new Date();
    if (selectedDate && this.isSameDate(selectedDate, today)) {
      const currentHour = today.getHours();
      const currentMinutes = today.getMinutes();
      this.minTime = `${this.padZero(currentHour)}:${this.padZero(
        currentMinutes
      )}`;
    } else {
      this.minTime = '00:01';
    }
  }
  isSameDate(date1: Date, date2: Date): boolean {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }
  padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }
  filterHosts(value: string) {
    // Implement your filtering logic here
    const filterValue = value.toLowerCase();
    return this.users.filter((host) =>
      `${host.firstname} ${host.lastname}`.toLowerCase().includes(filterValue)
    );
  }
  setUserListdata(users: UserRegDetails[]) {
    this.users = users;
  }
  toggleOption(i: number) {
    if (i === this.getMaxIndex()) {
      this.addOption(i);
    } else this.removeOption(i);
  }
  getEmptyOptions() {
    const hasEmptyOption = this.options.controls.some(
      (control) => control.value === ''
    );
    if (hasEmptyOption) {
      return true;
    } else return false;
  }
  addOption(i: number) {
    this.options.insert(i + 1, this.formBuilder.control(''));
  }

  removeOption(i: number) {
    if (this.options.length > 1) {
      this.options.removeAt(i);
    }
  }
  getMaxIndex(): number {
    return this.options.length - 1;
  }
  savePoll() {
    let selectedUsers = this.users.filter((user: any) => user.selected);

    const combinedStartDateTime = this.getCombinedDateTime(
      this.pollForm.get('startDate').value,
      this.pollForm.get('startTime').value
    );
    const combinedEndDateTime = this.getCombinedDateTime(
      this.pollForm.get('endDate').value,
      this.pollForm.get('endTime').value
    );
    this.pollForm
      .get('completeStartDate')
      .patchValue(combinedStartDateTime.toISOString());
    this.pollForm
      .get('completeEndDate')
      .patchValue(combinedEndDateTime.toISOString());

    this.onCreateUserPoll.emit(this.pollForm.value);
  }
  onChange(val: MatCheckboxChange, user: UserRegDetails) {
    if (val.checked) this.selected.push(this.formBuilder.control(user.userId));
    else {
      const indexToRemove = this.selected.value.findIndex(
        (userId: string) => userId === user.userId
      );
      if (indexToRemove !== -1) {
        this.selected.removeAt(indexToRemove);
      }
    }
  }
  sendResultsToChanged(value: string) {
    const usersFormArray = this.pollForm.get('users') as FormArray;

    while (usersFormArray.length !== 0) {
      usersFormArray.removeAt(0);
    }

    if (value === 'select') {
      this.users.forEach(() => {
        usersFormArray.push(this.formBuilder.control(false));
      });
    }
  }
  getCombinedDateTime(selectedDate: any, Time: any) {
    const startDateValue = selectedDate as Date;
    const startTimeValue = Time as string;
    const [time, period] = startTimeValue.split(' ');
    const [hoursStr, minutesStr] = time.split(':');
    let hours = Number(hoursStr);
    const minutes = Number(minutesStr);
    if (period === 'PM' && hours < 12) {
      hours += 12;
    } else if (period === 'AM' && hours === 12) {
      hours = 0;
    }
    const combinedDateTime = new Date(startDateValue);
    combinedDateTime.setHours(hours);
    combinedDateTime.setMinutes(minutes);
    return combinedDateTime;
  }
  captureDivAsImage() {
    const pollCardElement = document.querySelector('.poll-card') as HTMLElement; // Cast to HTMLElement

    if (pollCardElement) {
      html2canvas(pollCardElement).then((canvas) => {
        // Convert the captured content to an image
        const image = canvas.toDataURL('image/png');
        this.pollImage = image;
        this.pollForm.get('pollImage').setValue(image);
        this.savePoll();
      });
    }
  }
  // Function to add selected users to the array
  addUser(event: any): void {
    const value = event.option.value;
    if (value && !this.usersTemp.includes(value)) {
      this.usersTemp.push(value);
      const matchedUser = this.users.find(
        (user) =>
          (user.firstname + ' ' + user.lastname).toLowerCase() ===
          value.toLowerCase()
      );
      this.selected.push(this.formBuilder.control(matchedUser.userId));
    }
    setTimeout(() => {
      this.selectedUsersControl.setValue('');
    }, 250);
    event.option.deselect();
  }
  isSaveDiabled() {
    if (this.pollForm.get('sendResultsTo').value === 'select') {
      if (this.usersTemp.length == 0 || this.pollForm.invalid) {
        return true;
      } else return false;
    }
    return this.pollForm.invalid;
  }

  // Function to remove a user from the array
  removeUser(user: string): void {
    const index = this.usersTemp.indexOf(user);
    const formArray = this.pollForm.get('selected') as FormArray;
    if (index >= 0) {
      this.usersTemp.splice(index, 1);
      formArray.removeAt(index);
    }
  }
  clearInputField(): void {
    this.selectedUsersControl.setValue(''); // Clear the input field value
  }

  ScreenType = ScreenType;
}
